import type { Crumb } from "shared/components/BreadCrumbs";

export const CRUMBS: Crumb[] = [
  { title: "Settings", href: "/settings" },
  { title: "Branding", href: "/settings/branding" }
];

export const QUERY_ACCOUNT_BRANDING = ["BRANDING", "ACCOUNT"];
export const QUERY_BRANDING_COMMUNITIES = ["BRANDING", "COMMUNITIES"];

export const COMMUNITIES_PER_PAGE = 20;
export const SEARCH_DEBOUNCE_MS = 500;
export const DEFAULT_PRIMARY_COLOR = "#E6007E";

// Deep link from a Community's detail page: /settings/branding?community=<id>&search=<name>
export const COMMUNITY_PARAM = "community";
export const SEARCH_PARAM = "search";
